import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcFeedback = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M3 4.706a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-6.586a1 1 0 0 0-.707.293l-4 4c-.63.63-1.707.184-1.707-.707v-2.586a1 1 0 0 0-1-1 2 2 0 0 1-2-2v-10Zm4 3a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h5a1 1 0 0 0 0-2H8Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
})), "IcFeedback");

export { IcFeedback };
//# sourceMappingURL=ic-feedback.js.map
